const bearingDetail = {
  bearingId: null,
  recordKey: "",
  alignmentIssues: "",
  anchorBolt: "",
  bearingArea: "",
  bearingComment: "",
  bearingCount: null,
  bearingLocation: "",
  bearingMovement: "",
  bearingSubstrUnit: "",
  bearingType: "",
  conditionRating: "",
  corrosion: "",
  ecmsId: "",
  installDate: null,
  updateDateTime: "",
  replacementComment: "",
  replacementReason: "",
  updateUserId: "",
};
export { bearingDetail };
